export const characterDetails = {
  'Wyatt Mercer': {
    age: '24',
    origin: 'Magnolia, Texas',
    power: 'Four Bound Relics',
    quote: 'I just want to be left alone.',
    backstory: 'A graveyard-shift clerk at the Kwik-Stop, Wyatt was marked UNCLAIMED by a blast of raw magic. Bonded to a box cutter, a cracked phone, an expired bus pass, and a pair of cowboy boots, he has nine days to become the protector his town needs.',
    traits: ['Deadpan', 'Reluctant', 'Loyal']
  },
  Dusty: {
    age: 'Unknown',
    origin: 'The streets of Magnolia',
    power: 'Senses hidden magic',
    quote: 'Never claimed. Only chosen.',
    backstory: 'A stray who belongs to no one, Dusty can sense magic that no one else can. He left a permanent scar on Silas Crane, and he matters far more to this war than anyone realizes.',
    traits: ['Fearless', 'Intuitive', 'Devoted']
  },
  Ressa: {
    age: 'Older than she looks',
    origin: 'Bound by contract',
    power: 'Magical fixer',
    quote: 'Everything I do costs me something.',
    backstory: 'A burned-out fixer held by a magical contract. The darker her eyes grow at the edges, the more of herself she has spent, and she is running low.',
    traits: ['World-weary', 'Resourceful', 'Sharp-tongued']
  },
  'Adrienne Voss': {
    age: '40s',
    origin: 'Voss-Kline Development',
    power: 'Claim and contract',
    quote: 'Land is only a question of ownership.',
    backstory: 'The polished CEO of Voss-Kline Development. She has a plan for the ley-line beneath Magnolia and no interest in asking permission from the people living on top of it.',
    traits: ['Calculating', 'Polished', 'Ruthless']
  },
  'Silas Crane': {
    age: 'Unknown',
    origin: 'Claimed by Voss',
    power: 'Surrendered Claim',
    quote: 'I gave up everything to be useful.',
    backstory: 'His eyes are blacked out by total surrender to his Claim. Voss uses him as her enforcer, and the scar Dusty left across his face is the one thing he cannot hide.',
    traits: ['Relentless', 'Hollow', 'Obedient']
  },
  Husk: {
    age: 'Not applicable',
    origin: 'Severed from a Claim',
    power: 'Hunts every spark of magic',
    quote: 'Hungry.',
    backstory: 'Once claimed, then violently severed. Some still speak and wear a human face until pain cracks it. The rest are pure hunger, hunting every spark of magic they can sense.',
    traits: ['Feral', 'Tragic', 'Insatiable']
  }
};
